import { assetAllocation } from "../../engine/calculations";

const RISK_NOTES = {
  conservative: "A conservative mix prioritises stability with more debt and less equity.",
  moderate: "A balanced mix aims for growth while cushioning against sharp swings.",
  aggressive: "An aggressive mix leans into equity for higher long-term growth potential.",
};

const assetAllocationConfig = {
  key: "asset-allocation",
  title: "Asset Allocation",
  category: "Wealth Strategies",
  description: "A starting equity / debt / gold split based on your risk profile.",
  fields: [
    {
      key: "riskProfile",
      label: "Risk profile",
      type: "select",
      default: "moderate",
      options: [
        { value: "conservative", label: "Conservative" },
        { value: "moderate", label: "Moderate" },
        { value: "aggressive", label: "Aggressive" },
      ],
    },
    { key: "age", label: "Age", type: "number", default: 35, min: 18, max: 100, optional: true, help: "Not used to change the split yet — reserved for a future age-based tilt." },
  ],
  chart: { type: "donut", nameKey: "name", valueKey: "value" },
  compute(values) {
    const allocation = assetAllocation(values.riskProfile);
    const entries = [
      { name: "Equity", value: allocation.equity },
      { name: "Debt", value: allocation.debt },
      { name: "Gold", value: allocation.gold },
    ];

    return {
      headline: {
        label: "Suggested split",
        display: entries.map((e) => `${Math.round(e.value * 100)}% ${e.name}`).join(" / "),
      },
      note: RISK_NOTES[values.riskProfile] || RISK_NOTES.moderate,
      breakdown: entries.map((e) => ({ label: e.name, value: e.value, format: "percent" })),
      series: entries,
    };
  },
};

export default assetAllocationConfig;
